export const environment = {
  production: true,
  hmr: false,
  apiUrl: "http://localhost:4000",
  ENCRIPTY_KEY: "Fischereiverband"
};
